import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Loader2 } from 'lucide-react';
import { userService } from '../../_services';

function AssignGroupNumber({
    text,
    closeAssignGroupPopup,
    openCampaignPopup,
    openEditScreenPopup,
    openManageGroup,
    SelectedGroupNumber,
    MaxComm,
    cPagin,
    cSearch,
    reopenFlag,
    allData
}) {
    const [userType, setUserType] = useState('Distributor');
    const [whAdvanceSetting, setWhAdvanceSetting] = useState({});
    const [loading, setLoading] = useState(true);

    const userdata = useMemo(() => {
        try {
            return JSON.parse(localStorage.getItem('user'));
        } catch {
            return null;
        }
    }, []);

    const fetchAdvanceSetting = useCallback(async () => {
        if (!userdata) {
            setLoading(false);
            return;
        }

        try {
            const whid = userdata.wholesaler_Id.toString();
            const apidata = await userService.GetAdvanceSetting('', '', whid);
            if (apidata?.length > 0 && apidata[0].settings?.[0]) {
                setWhAdvanceSetting(apidata[0].settings[0]);
                // If broker is available, set it as default
                if (apidata[0].settings[0].isBroker) {
                    setUserType('Broker');
                }
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    }, [userdata]);

    useEffect(() => {
        fetchAdvanceSetting();
    }, [fetchAdvanceSetting]);

    const handleSubmit = useCallback(() => {
        if (userType === 'Web Campaign') {
            closeAssignGroupPopup?.();
            openCampaignPopup?.('', '', '', '', userType, '');
        } else {
            closeAssignGroupPopup?.();
            openEditScreenPopup?.('', '', '', '', userType, SelectedGroupNumber);
        }
    }, [userType, closeAssignGroupPopup, openCampaignPopup, openEditScreenPopup, SelectedGroupNumber]);

    const handleBack = useCallback(() => {
        closeAssignGroupPopup?.();
        openManageGroup?.(SelectedGroupNumber, MaxComm, cPagin, cSearch, '', '', reopenFlag, allData);
    }, [closeAssignGroupPopup, openManageGroup, SelectedGroupNumber, MaxComm, cPagin, cSearch, reopenFlag, allData]);

    const handleOpenChange = useCallback((open) => {
        if (!open) {
            handleBack();
        }
    }, [handleBack]);

    const userTypeOptions = useMemo(() => {
        const options = [];
        if (whAdvanceSetting.isBroker) {
            options.push({ value: 'Broker', label: 'Broker' });
        }
        options.push(
            { value: 'Distributor', label: 'Distributor' },
            { value: 'Email Campaign', label: 'Email Campaign' },
            { value: 'IBO/Marketplace', label: 'IBO/Marketplace' },
            { value: 'Mail Campaign', label: 'Mail Campaign' },
            { value: 'SMS Campaign', label: 'SMS Campaign' },
            { value: 'Web Campaign', label: 'Web Campaign' },
            { value: 'Other', label: 'Other' }
        );
        return options;
    }, [whAdvanceSetting.isBroker]);

    return (
        <Dialog open={true} onOpenChange={handleOpenChange}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>{text}</DialogTitle>
                </DialogHeader>

                <div className="space-y-4 py-4">
                    {loading ? (
                        <div className="flex items-center justify-center py-8">
                            <Loader2 className="h-8 w-8 animate-spin text-primary" />
                        </div>
                    ) : (
                        <div className="space-y-2">
                            <Label htmlFor="userType">Select a User Type</Label>
                            <Select value={userType} onValueChange={setUserType}>
                                <SelectTrigger id="userType">
                                    <SelectValue placeholder="Select user type" />
                                </SelectTrigger>
                                <SelectContent>
                                    {userTypeOptions.map((option) => (
                                        <SelectItem key={option.value} value={option.value}>
                                            {option.label}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        </div>
                    )}
                </div>

                <DialogFooter>
                    <Button onClick={handleSubmit} disabled={loading}>
                        Submit
                    </Button>
                    <Button variant="secondary" onClick={handleBack}>
                        Cancel
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default AssignGroupNumber;
